// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedView_root"};